import moment from "moment";

import { TimeSlot } from "./TimeSlotSelector";

// Keep in sync with backend settings
export const DEFAULT_CALENDAR_DAYS = 180;

export function getTimeslotsByDate(
  timeslots: TimeSlot[] = [],
  date: Date,
  timezone = "UTC",
): TimeSlot[] {
  const dateString = moment(date).format("MM-DD-YYYY");

  return timeslots.filter((timeslot) => {
    const timeslotByClientTimezone = moment(timeslot.timeSlot)
      .tz(timezone)
      .format("MM-DD-YYYY");
    return dateString === timeslotByClientTimezone;
  });
}

export function mapCalendarDate(timeslots: TimeSlot[] = [], timezone = "UTC") {
  return timeslots.reduce((res, timeslot) => {
    const timeslotByClientTimezone = moment(timeslot.timeSlot).tz(timezone);
    res[timeslotByClientTimezone.format("MM-DD-YYYY")] = true;
    return res;
  }, {});
}
